var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('navbar'),_c('b-container',[_vm._t("default")],2),_c('b-modal',{ref:"versionModal",attrs:{"centered":"","id":"versionModal","size":"lg","lazy":"","no-close-on-backdrop":false,"ok-title":"Loka","ok-only":true,"title":"Útgáfur"}},[_c('versions-modal',{ref:"versionModal"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }